import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import { LocationTagItem } from './location-tag-item';

type LocationTagsProps = {
  tags: string[];
  className?: string;
};

export const LocationTags = ({ tags, className }: LocationTagsProps) => (
  <Container className={className}>
    {tags?.map((tag) => (
      <LocationTagItem key={tag} tagId={tag} />
    ))}
  </Container>
);

const Container = styled.div.attrs({
  className: createReadableClass({
    component: 'location-tags'
  })
})``;
